import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

import { KeyValueFormattingModel, KeyValueRestrictionModel } from '@models/module/fields/enums';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { PipesModule } from '@shared/modules/pipes.module';

@Component({
  selector: 'itv-number-progress-bar',
  templateUrl: './number-progress-bar.component.html',
  styleUrls: ['./number-progress-bar.component.scss'],
  imports: [PipesModule, MatIconModule, FlexLayoutModule],
})
export class NumberProgressBarComponent {
  @Input() value: number | string;
  @Input() formattings: KeyValueFormattingModel[];
  @Input() restrictions: KeyValueRestrictionModel[];
  @Input() isDuration: boolean;

  get valuePercent() {
    if (!this.value) {
      return '0%';
    }
    if (typeof this.value == 'number') {
      return `${this.value}%`;
    }
    if (this.value.endsWith('%')) {
      return this.value;
    }
    return `${this.value}%`;
  }
}
